module.exports = __webpack_public_path__ + "img/30c4582.png";